var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1H28C34.0751 1 39 5.92487 39 12V28C39 34.0751 34.0751 39 28 39H12C5.92487 39 1 34.0751 1 28V12Z",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_292",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 18,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.7998H11V27.1998H29V12.7998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_292)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.7998C20.7695 12.7998 21.5588 12.8196 22.3238 12.852L23.2274 12.8952L24.0923 12.9465L24.9023 13.0014L25.6421 13.059C26.4449 13.1204 27.2004 13.463 27.7756 14.0265C28.3507 14.59 28.7088 15.3383 28.7867 16.1397L28.8227 16.5222L28.8902 17.3412C28.9532 18.1899 29 19.1151 29 19.9998C29 20.8845 28.9532 21.8097 28.8902 22.6584L28.8227 23.4774C28.811 23.6088 28.7993 23.7357 28.7867 23.8599C28.7088 24.6614 28.3506 25.4098 27.7752 25.9733C27.1999 26.5368 26.4442 26.8793 25.6412 26.9406L24.9032 26.9973L24.0932 27.0531L23.2274 27.1044L22.3238 27.1476C21.5496 27.1812 20.7749 27.1986 20 27.1998C19.2251 27.1986 18.4503 27.1812 17.6762 27.1476L16.7726 27.1044L15.9077 27.0531L15.0977 26.9973L14.3579 26.9406C13.5551 26.8791 12.7996 26.5365 12.2244 25.9731C11.6493 25.4096 11.2912 24.6613 11.2133 23.8599L11.1773 23.4774L11.1098 22.6584C11.041 21.7738 11.0044 20.887 11 19.9998C11 19.1151 11.0468 18.1899 11.1098 17.3412L11.1773 16.5222C11.189 16.3908 11.2007 16.2639 11.2133 16.1397C11.2912 15.3384 11.6491 14.5903 12.2241 14.0268C12.7991 13.4633 13.5543 13.1206 14.357 13.059L15.0959 13.0014L15.9059 12.9465L16.7717 12.8952L17.6753 12.852C18.4497 12.8184 19.2248 12.801 20 12.7998ZM18.2 17.8173V22.1823C18.2 22.5981 18.65 22.8573 19.01 22.6503L22.79 20.4678C22.8723 20.4204 22.9406 20.3522 22.9881 20.2701C23.0356 20.1879 23.0606 20.0947 23.0606 19.9998C23.0606 19.9049 23.0356 19.8116 22.9881 19.7295C22.9406 19.6473 22.8723 19.5791 22.79 19.5318L19.01 17.3502C18.9279 17.3028 18.8347 17.2778 18.7399 17.2778C18.6451 17.2779 18.552 17.3028 18.4698 17.3503C18.3877 17.3977 18.3196 17.4659 18.2722 17.5481C18.2248 17.6302 18.1999 17.7225 18.2 17.8173Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.c43896fb23ea7a40715e4e25a283638f.svg";
export { ForwardRef as ReactComponent };